import React, { FC } from 'react';
import { APIS } from '../../../../lib/constants/apis';
// import MUIAlert from '../../../../components/ui-component/mui-alert/MUIAlert';
// import { useApplication } from '../../../../context/ApplicationContext';

// import MittelAbrufSchema from '../../../../lib/paths/mittelabruf_FULL_Paths.json';
// import { get } from 'lodash';
// const MA_P = MittelAbrufSchema.attributes;

const AntragZusatzInfo: FC<{ api: string }> = ({ api }) => {
	// const { application, readOnly } = useApplication();
	const Render = () => {
		switch (api) {
			case APIS.Mittelabruf:
				// 				if (readOnly && !get(application, `${MA_P.Mittelabruf_Verwendungsnachweiss.path}.id`)) {
				// 					return (
				// 						<>
				// 							<MUIAlert
				// 								title="Achtung:"
				// 								message="Sie müssen für jeden Mittelabruf einen Verwendungsnachweis einreichen.
				// Erstellen Sie den Verwendungsnachweis, indem Sie auf den Button unten rechts klicken"
				// 							/>
				// 						</>
				// 					);
				// 				}
				return <></>;

			default:
				return <></>;
		}
	};
	return (
		<>
			<Render />
		</>
	);
};
export default AntragZusatzInfo;
